<template>
  <figure class="item-venta" :id="`item-venta-${idCategoria}`">
    <div class="btnAgregarServicio recuperarBoton" :idCategoria="idCategoria">
      <img :src="image" alt="item venta" />
      <figcaption>
        <h6 class="nombre-item">{{itemName}}</h6>
      </figcaption>
    </div>
  </figure>
</template>

<script>
import dfltIMG from "@/assets/img/servicios/default.png";

export default {
  props: {
    codigo: Number,
    itemName: String,
    idCategoria: Number,
    itemCategoria: String,
    imageUrl: String
  },
  computed: {
    image(){
      return (
        (this.imageUrl === "" || this.imageUrl == undefined || this.imageUrl == null) 
        ? dfltIMG : `local-resource://${this.imageUrl}`
      );
    }, 
  },
  methods: {
    handleItemClick: function() {}
  }
};
</script>

<style scoped>
.item-venta {
  width: 80px;
  max-width: 95px;
  min-width: 75px;
  /* margin: 3px 5px; */
  margin: .7rem .7rem;
  padding: 0;
  position: relative;
  background-image: linear-gradient(to right bottom, cyan, violet);
  border-radius: 3px;
  cursor: pointer;
  line-height: 0;
}

.item-venta:hover {
  transform: translateY(-3px) scale(100.5%);
  transition: all 0.2s ease-out;
}

.item-venta:active {
  transform: translateY(1px) scale(99.5%);
  transition: all 0.2s ease-out;
}

.item-venta:active .caption {
  background-image: linear-gradient(to right bottom, violet, darkblue, cyan);
  transition: all 0.7s ease-out;
}

.item-venta img {
  width: 100%;
  max-height: 70px;
  min-height: 70px;
  margin-left: 0;
  margin-right: auto;
  object-fit: fill;
}

.item-venta figcaption {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  min-height: 45px;
  background-image: linear-gradient(
    to right bottom,
    rgb(157, 104, 255),
    rgb(65, 139, 207),
    rgb(34, 0, 158)
  );
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  opacity: 1;
  transition: all ease-in-out 300ms;
}

.item-venta .nombre-item {
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
  font-size: 0.6rem;
}
</style>